// src/components/ListZonededefense.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from '../helpers/axiosConfig';

const ListZonededefense = () => {
  const [zones, setZones] = useState([]);

  useEffect(() => {
    const fetchZones = async () => {
      try {
        const response = await axios.get('/zonededefenses'); // Assurez-vous que cette route est correcte
        setZones(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des zones de défense:', error);
      }
    };

    fetchZones();
  }, []);

  return (
    <div className="container mt-3 ">
      <h1>Liste des Zones de Défense</h1>
      <Link to="/zonededefenses/add" className="btn btn-primary mb-3">
        Ajouter une Zone de Défense
      </Link>
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Libellé</th>
            <th>Observation</th>
            <th>Photo</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {zones.map((zone) => (
            <tr key={zone.id}>
              <td>{zone.name}</td>
              <td>{zone.libelle}</td>
              <td>{zone.observation}</td>
              <td>
                {zone.filename ? (
                  <img
                    src={`http://localhost:3001/images/zonedefenses/${zone.filename}`}
                    alt={zone.name}
                    style={{
                      width: '50px',
                      height: '50px',
                      objectFit: 'cover',
                    }}
                  />
                ) : (
                  'Pas de photo'
                )}
              </td>
              <td>
                <Link to={`/zonededefenses/edit/${zone.id}`} className="btn btn-warning btn-sm me-2">
                  Modifier
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ListZonededefense;
